import {Injectable} from "@angular/core";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {AdvertisementPublicationPeriodEnum} from "../../core/enums/advertisement-publication-period.enum";

@Injectable({providedIn: 'root'})
export class PaymentRestService {
  constructor(private readonly http: HttpClient) {
  }

  public getListingPricingPreview(
    highlightRequested: boolean,
    period: AdvertisementPublicationPeriodEnum,
    highlightPaid: boolean = false
  ): Observable<any> {
    const params = new HttpParams()
      .set('highlightRequested', String(highlightRequested))
      .set('period', period)
      .set('highlightPaid', String(highlightPaid));
    return this.http.get<any>(`${environment.apiUrl}/payments/listing-pricing-preview`, {params});
  }

  public getListingSummary(slug: string): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/marketplace_advertisements/${slug}/summary`);
  }

  public checkoutListing(slug: string, preferAppReturn: boolean = false): Observable<any> {
    const headers = preferAppReturn
      ? new HttpHeaders({'X-WTG-Client-Platform': 'mobile-app'})
      : undefined;

    return this.http.post<any>(`${environment.apiUrl}/marketplace_advertisements/${slug}/checkout`, {
      preferAppReturn,
    }, {headers});
  }

  public resolveListingPayment(slug: string): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/marketplace_advertisements/${slug}/resolve-payment`);
  }

  public getPayment(publicId: string): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/payments/${publicId}`);
  }
}
